<template>
<div class="chapter">
<div class="inner_page">
<h3 class="BHD">Classic vanilla</h3>
<p class="BOD1">Light and luscious, this vanilla sponge recipe will never fail to produce a great sponge base for the most fabulous decorations. If you fancy a change for a more zingy flavour, simply follow the suggestions for a citrus version.</p>
<h4 class="MLAHD">You will need… makes about 12</h4>
<ul>
<li>125g (4<span class="fractions"><sup>1</sup>⁄<sub>2</sub></span>oz) margarine, softened</li>
<li>125g (4<span class="fractions"><sup>1</sup>⁄<sub>2</sub></span>oz) caster (superfine) sugar</li>
<li>1 tsp (5ml) vanilla extract</li>
<li>2 eggs (medium or large), lightly beaten</li>
<li>125g (4<span class="fractions"><sup>1</sup>⁄<sub>2</sub></span>oz) self-raising (-rising) flour</li>
<li>2 tbsp (30ml) milk</li>
</ul>
<p class="SbS1"><strong>1</strong> Preheat the oven to 200°C/fan 180°C/400°F/Gas Mark 6. Line your muffin tray (pan) with muffin cases (liners) and set to one side.</p>
<p class="SbS1"><strong>2</strong> Place the margarine, sugar and vanilla extract in the bowl of an electric stand mixer and cream together until light and fluffy.</p>
<p class="SbS1"><strong>3</strong> Add the eggs gradually and then sift the flour into the mixture and combine on a low speed. Add the milk to make a smooth dropping consistency.</p>
<p class="SbS1"><strong>4</strong> Spoon the mixture evenly into the cases or fill a large disposable plastic piping (pastry) bag with the batter, snip off the end and pipe it into the muffin cases.</p>
<p class="SbS1"><strong>5</strong> Bake for 25–28 minutes, or until risen and springy to the touch. Cool on a wire rack.</p>
<div class="SBDIV">
<p class="SbS1"><strong>To</strong> vary the flavour of the sponge, for lemon or orange, replace the vanilla extract with a teaspoon of lemon or orange oil. For a more zingy citrus taste, add the finely grated zest of one washed unwaxed lemon or orange. For a chocolate chip option, add 100g (3<span class="fractions"><sup>1</sup>⁄<sub>2</sub></span>oz) dark (semisweet or bittersweet) or milk chocolate chips.</p>
</div>
<p class="Image"><img alt="" src="images/120314_BMIY_210_fmt.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// c04.vue?97124430